import { useMemo } from "react";
import { useReportsMetaSelector } from "store";

export const useSimpleMeasures = (): (string | number)[] => {
  const { assetClasses, measures, measureClasses } = useReportsMetaSelector();

  return useMemo(() => {
    const result: (string | number)[] = [...measures];
    assetClasses.forEach((asset) => {
      if (asset.measures.length) {
        asset.measures.forEach((item) => result.push(item));
      }
    });

    const somethingFromOre = measureClasses.map((mc) => mc.title);

    if (somethingFromOre.length > 0) {
      somethingFromOre.forEach((item) => result.push(item));
    }

    return Array.from(new Set(result));
  }, [assetClasses, measures]);
};
